import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getCampaign } from "generated/api/campaign";
import { campaignKeys } from "hooks/api/query-keys";

const campaignApi = getCampaign();

/**
 * Resolves the synthetic "program templates" campaign id for a client. Program
 * templates are stored under a dedicated campaign, whose id the table queries
 * depend on.
 */
export const useProgramTemplatesCampaignId = (
  clientId: string | undefined,
  options?: Omit<UseQueryOptions<string, Error, string>, "queryKey" | "queryFn">,
) => {
  return useQuery({
    queryKey: campaignKeys.programTemplatesCampaignId(clientId ?? ""),
    queryFn: () => {
      if (!clientId) {
        throw new Error("Client ID is required for useProgramTemplatesCampaignId");
      }
      return campaignApi.getProgramTemplatesCampaignId({ clientId });
    },
    ...options,
    enabled: !!clientId && (options?.enabled ?? true),
  });
};
